import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle, useMap } from "react-leaflet";
import L from "leaflet";

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// Module-level constants — stable identity across renders
const CIRCLE_PATH_OPTIONS = { color: "#E11D48", weight: 1.5, fillOpacity: 0.07 };
const TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const TILE_ATTRIBUTION = "© OpenStreetMap";
const MAP_STYLE = { height: "100%", width: "100%" };

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, map.getZoom());
  }, [center, map]);
  return null;
}

function RideMarker({ ride, onClick }) {
  const pos = [ride.location?.lat, ride.location?.lng];
  if (!pos[0] || !pos[1]) return null;
  return (
    <Marker position={pos} eventHandlers={{ click: () => onClick?.(ride) }}>
      <Popup>
        <div className="text-xs">
          <div className="font-bold">{ride.title}</div>
          <div>{ride.location?.name}</div>
          <div>{ride.distance_km} km · D+ {ride.elevation_m}</div>
        </div>
      </Popup>
    </Marker>
  );
}

export default function RideMap({ center, zoom = 9, radiusKm, rides = [], onMarkerClick }) {
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);
  if (!ready || !center) return null;

  return (
    <MapContainer center={center} zoom={zoom} style={MAP_STYLE} scrollWheelZoom>
      <TileLayer attribution={TILE_ATTRIBUTION} url={TILE_URL} />
      <Recenter center={center} />
      {radiusKm > 0 && (
        <Circle center={center} radius={radiusKm * 1000} pathOptions={CIRCLE_PATH_OPTIONS} />
      )}
      {rides.map((r) => (
        <RideMarker key={r.ride_id} ride={r} onClick={onMarkerClick} />
      ))}
    </MapContainer>
  );
}
